import React from 'react';
import styles from './Button.module.css';

function Button({ children, variant = 'primary', size = 'md', disabled, loading, onClick, type = 'button', className, ...props }) {
  const cls = [
    styles.btn,
    styles[variant],
    styles[size],
    loading ? styles.loading : '',
    className || ''
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={cls}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && <span className={styles.spinner} />}
      {children}
    </button>
  );
}

export default Button;
